import { BffApiCreateItemError } from '../../../../types';
import { useBffCreateQuery } from '../../../common/reactQuery/hooks/useBffCreateQuery';
import { LifestyleGenerationsBffUrl } from '../../LifestyleGenerationsBffUrl';
import {
  CreateLifestyleGenerationInput,
  CreateLifestyleGenerationResponse
} from '../../lifestyleGenerationsTypes';

function useCreateLifestyleGeneration() {
  const {
    createQueryData,
    createQuery,
    createQueryReset,
    createQueryError,
    createQueryErrorMessage,
    createQueryLoading
  } = useBffCreateQuery<
    CreateLifestyleGenerationInput,
    CreateLifestyleGenerationResponse,
    BffApiCreateItemError,
    CreateLifestyleGenerationResponse
  >({
    url: LifestyleGenerationsBffUrl.create()
  });

  return {
    createLifestyleGenerationData: createQueryData,
    createLifestyleGenerationError: createQueryError,
    createLifestyleGenerationLoading: createQueryLoading,
    createLifestyleGenerationErrorMessage: createQueryErrorMessage,
    createLifestyleGeneration: createQuery,
    createLifestyleGenerationReset: createQueryReset
  };
}

export default useCreateLifestyleGeneration;
